export default {
  // 页面标题和面包屑
  'pages.guest.title': '访客登记管理',
  'pages.guest.breadcrumb.person': '人员管理',
  'pages.guest.breadcrumb.guest': '访客登记',

  // 副标题配置
  'pages.guest.subtitle.canEnterEarly': '审核通过后，可以提前',
  'pages.guest.subtitle.hoursEnter': '小时进入，如果超过',
  'pages.guest.subtitle.hoursCannotEnter': '小时后将无法进入小区',

  // 按钮
  'pages.guest.button.settings': '设置',

  // 模态框
  'pages.guest.modal.config.title': '访客时间配置',
  'pages.guest.modal.config.save': '保存',
  'pages.guest.modal.config.cancel': '取消',

  // 表单标签
  'pages.guest.form.beforeHours.label': '提前进入时间（小时）',
  'pages.guest.form.beforeHours.placeholder': '请输入提前进入时间',
  'pages.guest.form.beforeHours.required': '请输入提前进入时间',
  'pages.guest.form.beforeHours.range': '请输入0-24之间的数字',

  'pages.guest.form.afterHours.label': '超时限制时间（小时）',
  'pages.guest.form.afterHours.placeholder': '请输入超时限制时间',
  'pages.guest.form.afterHours.required': '请输入超时限制时间',
  'pages.guest.form.afterHours.range': '请输入1-168之间的数字',

  // 消息
  'pages.guest.message.configUpdateSuccess': '配置更新成功',
  'pages.guest.message.configUpdateFailed': '配置更新失败',

  // 表格相关
  'pages.guest.table.title': '访客登记列表',
  'pages.guest.table.columns.houseInfo': '被访房屋',
  'pages.guest.table.columns.ownerName': '被访业主',
  'pages.guest.table.columns.guestName': '访客姓名',
  'pages.guest.table.columns.qrcode': '二维码',
  'pages.guest.table.columns.guestPhone': '联系电话',
  'pages.guest.table.columns.visitTime': '来访时间',
  'pages.guest.table.columns.leaveTime': '离开时间',
  'pages.guest.table.columns.status': '状态',
  'pages.guest.table.columns.createdTime': '创建时间',
  'pages.guest.table.columns.remarks': '备注',
  'pages.guest.table.columns.action': '操作',

  // 按钮
  'pages.guest.button.create': '新建登记',
  'pages.guest.button.view': '查看',
  'pages.guest.button.audit': '审核',
  'pages.guest.button.reject': '拒绝',
  'pages.guest.button.close': '关闭',

  // 详情模态框
  'pages.guest.detail.title': '访客登记详情',
  'pages.guest.detail.sections.guestInfo': '访客信息',
  'pages.guest.detail.sections.visitInfo': '来访信息',
  'pages.guest.detail.sections.visitedInfo': '被访信息',
  'pages.guest.detail.sections.idCard': '证件照',
  'pages.guest.detail.sections.systemInfo': '系统信息',

  // 字段标签
  'pages.guest.detail.fields.guestName': '访客姓名',
  'pages.guest.detail.fields.guestPhone': '联系电话',
  'pages.guest.detail.fields.idCard': '身份证号',
  'pages.guest.detail.fields.visitTime': '来访时间',
  'pages.guest.detail.fields.leaveTime': '离开时间',
  'pages.guest.detail.fields.status': '访客状态',
  'pages.guest.detail.fields.remarks': '备注',
  'pages.guest.detail.fields.houseInfo': '被访房屋',
  'pages.guest.detail.fields.ownerName': '被访业主',
  'pages.guest.detail.fields.ownerPhone': '业主电话',
  'pages.guest.detail.fields.createdTime': '创建时间',
  'pages.guest.detail.fields.updatedTime': '更新时间',

  // 状态相关
  'pages.guest.status.notLeave': '未离开',
  'pages.guest.status.none': '-',

  // 编辑/创建表单
  'pages.guest.form.create.title': '新建访客登记',
  'pages.guest.form.edit.title': '编辑访客登记',
  'pages.guest.form.submit.create': '创建',
  'pages.guest.form.submit.update': '更新',
  'pages.guest.form.submit.cancel': '取消',

  // 表单分区
  'pages.guest.form.sections.guestInfo': '访客信息',
  'pages.guest.form.sections.visitedInfo': '被访信息',
  'pages.guest.form.sections.visitTime': '来访时间',
  'pages.guest.form.sections.remarks': '备注信息',

  // 表单字段
  'pages.guest.form.fields.guestName.label': '访客姓名',
  'pages.guest.form.fields.guestName.placeholder': '请输入访客姓名',
  'pages.guest.form.fields.guestName.required': '请输入访客姓名',
  'pages.guest.form.fields.guestName.maxLength': '访客姓名不能超过50个字符',

  'pages.guest.form.fields.guestPhone.label': '联系电话',
  'pages.guest.form.fields.guestPhone.placeholder': '请输入联系电话',
  'pages.guest.form.fields.guestPhone.required': '请输入联系电话',

  'pages.guest.form.fields.idCard.label': '身份证号',
  'pages.guest.form.fields.idCard.placeholder': '请输入身份证号',

  'pages.guest.form.fields.idCardPhoto.label': '证件照',
  'pages.guest.form.fields.idCardPhoto.upload': '上传图片',
  'pages.guest.form.fields.idCardPhoto.uploading': '上传中',
  'pages.guest.form.fields.idCardPhoto.uploadError': '证件照上传失败',
  'pages.guest.form.fields.idCardPhoto.uploadSuccess': '证件照上传成功',
  'pages.guest.form.fields.idCardPhoto.onlyImage': '只能上传图片文件!',
  'pages.guest.form.fields.idCardPhoto.sizeLimit': '图片大小不能超过5MB!',
  'pages.guest.form.fields.idCardPhoto.uploadHint': '已上传 {count} 张图片{emptyHint}',
  'pages.guest.form.fields.idCardPhoto.emptyHint': '，支持上传身份证正反面或其他证件照片',
  'pages.guest.form.fields.idCardPhoto.imageAlt': '证件照{index}',

  'pages.guest.form.fields.houseInfo.label': '被访房屋',
  'pages.guest.form.fields.houseInfo.placeholder': '请选择被访房屋',
  'pages.guest.form.fields.houseInfo.search': '查询',
  'pages.guest.form.fields.houseInfo.select': '请选择房屋后自动填充',

  'pages.guest.form.fields.ownerInfo.label': '被访业主',
  'pages.guest.form.fields.ownerInfo.placeholder': '请选择房屋后自动填充',

  'pages.guest.form.fields.visitTime.label': '来访时间',
  'pages.guest.form.fields.visitTime.placeholder': '请选择来访时间',
  'pages.guest.form.fields.visitTime.required': '请选择来访时间',

  'pages.guest.form.fields.leaveTime.label': '离开时间',
  'pages.guest.form.fields.leaveTime.placeholder': '请选择离开时间',

  'pages.guest.form.fields.status.label': '访客状态',
  'pages.guest.form.fields.status.placeholder': '请选择状态',
  'pages.guest.form.fields.status.required': '请选择状态',

  'pages.guest.form.fields.remarks.label': '备注',
  'pages.guest.form.fields.remarks.placeholder': '请输入备注信息',

  // 消息提示
  'pages.guest.message.create.success': '创建成功',
  'pages.guest.message.create.failed': '创建失败，请稍后重试',
  'pages.guest.message.update.success': '更新成功',
  'pages.guest.message.update.failed': '更新失败，请稍后重试',
  'pages.guest.message.reject.success': '已拒绝',
  'pages.guest.message.reject.failed': '拒绝失败',
  'pages.guest.message.audit.approve': '审核通过',
  'pages.guest.message.audit.reject': '已拒绝',
  'pages.guest.message.audit.failed': '审核失败，请稍后重试',
  'pages.guest.message.houseSelect.success': '房屋信息已自动填充',
  'pages.guest.message.qrCode.configError': '二维码URL配置不完整',
  'pages.guest.message.qrCode.downloadSuccess': '二维码已下载',
  'pages.guest.message.qrCode.copySuccess': '二维码已复制到剪贴板',
  'pages.guest.message.qrCode.copyFailed': '复制失败，请使用下载功能',
  'pages.guest.message.qrCode.elementNotFound': '二维码元素未找到',
  'pages.guest.message.qrCode.copyFailedAlternative': '复制失败，请使用下载功能或尝试手动操作',
  'pages.guest.message.guestInfoNotExist': '访客信息不存在',

  // 审核相关
  'pages.guest.audit.title': '访客登记审核',
  'pages.guest.audit.approve': '通过',
  'pages.guest.audit.reject': '拒绝',
  'pages.guest.audit.remarks.label': '审核备注',
  'pages.guest.audit.remarks.placeholder': '请输入审核备注（选填）',
  'pages.guest.audit.confirm.approve': '确认通过',
  'pages.guest.audit.confirm.approve.description': '确定要通过此访客登记吗？',
  'pages.guest.audit.confirm.reject': '确认拒绝',
  'pages.guest.audit.confirm.reject.description': '确定要拒绝此访客登记吗？',

  // 二维码相关
  'pages.guest.qrCode.title': '访客二维码',
  'pages.guest.qrCode.openLink': '打开链接',
  'pages.guest.qrCode.copy': '复制二维码',
  'pages.guest.qrCode.download': '下载二维码',
  'pages.guest.qrCode.linkLabel': '链接地址：',

  // 表格分页
  'pages.guest.table.pagination.total': '共 {total} 条记录',

  // 默认状态文本
  'pages.guest.status.pending': '待审核',
  'pages.guest.status.registered': '已登记',
  'pages.guest.status.checked_in': '已进入',
  'pages.guest.status.checked_out': '已离开',
  'pages.guest.status.rejected': '已拒绝',
  'pages.guest.status.entered': '已进入',
  'pages.guest.status.left': '已离开',

  // Tooltip
  'pages.guest.tooltip.viewDetail': '查看详情',
  'pages.guest.tooltip.audit': '审核',
  'pages.guest.tooltip.reject': '拒绝',
  'pages.guest.tooltip.generateQrCode': '生成二维码',
};
